import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);




// app.get('/api5/aptitudes/:id', async (req, res) => {
//   try {
//       const result = await pool.query('SELECT * FROM aptitudes');
//       res.json(result.rows);
//   } catch (error) {
//       console.error('Error al obtener las aptitudes:', error);
//       res.status(500).json({ error: 'Error en la base de datos' });
//   }
// });

// app.post('/api5/nueva_aptitud', async (req, res) => {
//   const nuevaAptitud = req.body;
//   try {
//       const resultadoInsercion = await pool.query(`
//           INSERT INTO aptitudes (
//           id_tecnico,
//           equipo,
//           conocimiento

//           )
//           VALUES ($1, $2, $3)
//           RETURNING id
//       `, [
//           nuevaAptitud.id_tecnico,
//           nuevaAptitud.equipo,
//           nuevaAptitud.conocimiento
//       ]);
//       const nuevoID = resultadoInsercion.rows[0].id;
//       res.status(201).json({ message: 'Actividad realizada cargada exitosamente', id: nuevoID });
//   } catch (error) {
//       console.error(error);
//       res.status(500).json({ error: 'Error al subir' });
//   }
// });


